/**
 * @enum
 * @readonly
 */
const fileErrorMessages = {
  FILE_READER_API_NOT_SUPPORTED: 'Cannot crop Image. FileReader API not supported in your browser.',
  UNEXPECTED_ERROR: 'Something went wrong with your file. Please try to use another one.',
};


export default fileErrorMessages;
